module.exports = __webpack_public_path__ + "static/pain-6b40b0eac476d8092ab9abbd127fd2de.jpg";